/**
 * Customer Portal (UI) - referral partner dashboard variant.
 */
import type { DashboardResponse } from '../../types/portal';
import { MetricCardsGrid } from './MetricCardsGrid';

type ReferralPartnerDashboardProps = {
  dashboard: DashboardResponse;
};

export function ReferralPartnerDashboard({ dashboard }: ReferralPartnerDashboardProps) {
  return (
    <div className="row row-cards">
      <div className="col-12">
        <MetricCardsGrid
          title="Partner Account Performance Overview"
          description="Cross-account messaging KPIs for referral partner operations."
          metrics={dashboard.metrics}
        />
      </div>
    </div>
  );
}
